import { Box } from '@mui/material';

const KeyValueDisplay = ({ label, value }) => {
  if (!value) return null;

  return (
    <Box sx={{ columns: 2 }}>
      <Box>{label}:</Box>
      <Box>{value}</Box>
    </Box>
  );
};

export default KeyValueDisplay;
